/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { addMinutes, format } from "date-fns";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import TextError from "utils/TextError";
import * as Yup from "yup";
// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import ViewButton from "components/standardized-components/ViewButton";

import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  acceptPoNew,
  calculatePacketDetails,
  calculatePacketWeight,
  createAsn,
  createDynamicColumn,
  createPurchaseOrderNew,
  deletePurchaseOrderNew,
  editPurchaseOrderNew,
  getAttechmentClient,
  getBinsForPrint,
  getDeliveryPlantForPO,
  getDynamicColumn,
  getItemMaster,
  getPackageType,
  getPurchaseOrderNew,
  getSubModulesByRoleId,
  getUnloadingPointForPO,
  getVendorCodes,
  getVendorPurchaseOrder,
  publishPoNew,
  publishPurchaseOrder,
  rejectPoNew as rejectPo,
  uploadForPurchaseOrder,
} from "../../../store";

import "../../../index.css";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import Typography from "@mui/material/Typography";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import ReleaseButton from "components/standardized-components/ReleaseButton";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForCreatePo = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 0,
  pt: 3,
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  overflow: "scroll",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const CreatePO = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  createPurchaseOrderNew,
  editPurchaseOrderNew,
  deletePurchaseOrderNew,
  publishPurchaseOrder,
  uploadForPurchaseOrder,
  getPurchaseOrderNew,
  getVendorCodes,
  getPurchaseOrderReducer,
  itemMaster,
  getItemMaster,
  getVendorCodeReducer,
  publishPoNew,
  getPackageType,
  packageTypeReducer,
  createAsn,
  calculatePacketDetails,
  packageDetailsReducer,
  getDeliveryPlantForPO,
  getUnloadingPointForPO,
  deliveryPlantForPOReducer,
  unloadingPointForPOReducer,
  calculatePacketWeight,
  packetWeightReducer,
  getBinsForPrint,
  binsForPrintReducer,
  getVendorPurchaseOrder,
  getVendorPurchaseOrderReducer,
  // vendor actions
  acceptPoNew,
  rejectPo,
  getAttechmentClient,
  getAttechmentClientReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails?.data?.roleId;
  let email = loginDetails?.data?.email;

  let userId = loginDetails?.data?.userId;
  let roleName = loginDetails?.data?.roleName;

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  const vendorRolePattern = /vendor/i;
  const isVendor = vendorRolePattern.test(roleName);

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "84718389-a2fb-427c-a13c-ef5db6e504ab";

  let purchaseOrderModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "84718389-a2fb-427c-a13c-ef5db6e504ab",
  );

  let viewCreateAndPublishedPOAccess = purchaseOrderModule
    ? purchaseOrderModule.actionId.includes(
        "a43f93cd-5ddd-4a5b-bc51-763f440a72f7",
      )
    : null;

  // const clientRolePattern = /client/i;

  // const updatePOAccess = clientRolePattern.test(roleName);

  // let createPOAccess = clientRolePattern.test(roleName);

  // let deletePOAccess = clientRolePattern.test(roleName);

  // let publishPOAccess = clientRolePattern.test(roleName);

  // let acceptPOAccess = vendorRolePattern.test(roleName);

  // let rejectPOAccess = vendorRolePattern.test(roleName);

  const updatePOAccess = !isVendor;
  let createPOAccess = !isVendor;
  let deletePOAccess = !isVendor;
  let publishPOAccess = !isVendor;

  let acceptPOAccess = isVendor;
  let rejectPOAccess = isVendor;

  let viewAttachmentAccess = !isVendor;

  let viewAccess = true;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  // useEffect(() => {
  //   const t = setTimeout(() => {
  //     if (!jwtToken) return;
  //     if (
  //       roleName === "vendor" ||
  //       roleName === "Vendor" ||
  //       roleName === "VENDOR" ||
  //       roleName === "povendor"
  //     ) {
  //       getVendorPurchaseOrder(
  //         email,
  //         pageNo,
  //         rowsPerPage,
  //         searchObject,
  //         jwtToken
  //       );
  //     } else {
  //       getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);
  //     }
  //   }, 500);
  //   return () => clearTimeout(t);
  // }, [roleName, pageNo, rowsPerPage, searchObject]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!jwtToken) return;
      isVendor
        ? getVendorPurchaseOrder(
            email,
            pageNo,
            rowsPerPage,
            searchObject,
            jwtToken,
          )
        : getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);
    }, 500);

    return () => clearTimeout(t);
  }, [isVendor, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      { Header: "PO No.", accessor: "purchaseOrderNumber" },
      { Header: "PO LineNo.", accessor: "purchaseOrderLineNumber" },
      { Header: "Vendor Code", accessor: "vendorCode" },
      { Header: "Item code", accessor: "itemCode" },
      // { Header: "Item Description", accessor: "itemDescription" },
      { Header: "Po Date", accessor: "date" },
      { Header: "Qty", accessor: "qty" },
      { Header: "Unloading Point", accessor: "unloadingPoint" },
      { Header: "Delivery Plant", accessor: "deliveryPlant" },
      { Header: "Status", accessor: "status" },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;
  const [asnQtyChange, setAsnQtyChange] = useState("");
  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [isErrorForCreateOrder, setIsErrorForCreateOrder] = useState(false);
  const [isSuccessForCreateOrder, setIsSuccessForCreateOrder] = useState(false);

  useEffect(() => {
    if (isErrorForCreateOrder) {
      setTimeout(() => {
        setIsErrorForCreateOrder(false);
      }, 3000);
    }
  }, [isErrorForCreateOrder]);

  useEffect(() => {
    if (isSuccessForCreateOrder) {
      setTimeout(() => {
        setIsSuccessForCreateOrder(false);
      }, 3000);
    }
  }, [isSuccessForCreateOrder]);
  const [isErrorRelease, setIsErrorRelease] = useState(false);
  const [isSuccessRelease, setIsSuccessRelease] = useState(false);

  useEffect(() => {
    if (isErrorRelease) {
      setTimeout(() => {
        setIsErrorRelease(false);
      }, 3000);
    }
  }, [isErrorRelease]);

  useEffect(() => {
    if (isSuccessRelease) {
      setTimeout(() => {
        setIsSuccessRelease(false);
      }, 3000);
    }
  }, [isSuccessRelease]);

  const [asnCode, setAsnCode] = useState("");
  const [packageType, setPackageType] = useState("");

  useEffect(() => {
    getBinsForPrint(asnCode, jwtToken);
  }, [asnCode]);

  const [partCode, setPartCode] = useState("");

  const [purchaseOrderNumberOptions, setPurchaseOrderNumberOptions] = useState(
    [],
  );

  const [demandId, setDemandId] = useState("");

  useEffect(() => {
    getPackageType(partCode, jwtToken);
  }, [partCode]);

  useEffect(() => {
    calculatePacketWeight(partCode, asnQtyChange, jwtToken);
  }, [partCode, asnQtyChange]);

  useEffect(() => {
    getDeliveryPlantForPO(demandId, jwtToken);
  }, [demandId]);

  useEffect(() => {
    getUnloadingPointForPO(demandId, jwtToken);
  }, [demandId]);

  const [singleDeliveryPlantData, setSingleDeliveryPlantData] = useState("");
  const [singleUnloadingPointData, setSingleUnloadingPointData] = useState("");

  useEffect(() => {
    let data = deliveryPlantForPOReducer.deliveryPlantData.data
      ? deliveryPlantForPOReducer.deliveryPlantData.data
      : [];
    setSingleDeliveryPlantData(data?.deliveryPlant);
  }, [deliveryPlantForPOReducer]);

  useEffect(() => {
    let data = unloadingPointForPOReducer.unloadingPointData.data
      ? unloadingPointForPOReducer.unloadingPointData.data
      : [];
    setSingleUnloadingPointData(data.unloadingPoint);
  }, [unloadingPointForPOReducer]);

  const [loading, setLoading] = useState(true);
  const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
  const [attachmentUrl, setAttachmentUrl] = useState("");

  const onViewAttachmentClient = async (purchase) => {
    try {
      const res = await getAttechmentClient(
        {
          file_name: purchase.poName,
          file_type: purchase.poType,
          purchaseOrderId: purchase.purchaseOrderId,
        },
        jwtToken,
      );

      if (res?.status && res?.url) {
        let url = res.url;

        if (url.toLowerCase().endsWith(".pdf")) {
          url = `https://docs.google.com/gview?url=${encodeURIComponent(
            url,
          )}&embedded=true`;
        } else if (
          url.toLowerCase().endsWith(".jpg") ||
          url.toLowerCase().endsWith(".jpeg") ||
          url.toLowerCase().endsWith(".png")
        ) {
        }

        setAttachmentUrl(url);
        setOpenAttachmentModal(true);
      } else {
        toast.error("Attachment not found");
      }
    } catch (err) {
      // console.error("Attachment fetch error:", err);
      toast.error("Attachment fetch failed");
    }
  };

  useEffect(() => {
    let tempAsset = [];

    // const listState =
    //   roleName === "admin" ||
    //   roleName === "Admin" ||
    //   roleName === "spAdmin" ||
    //   roleName === "spadmin" ||
    //   roleName === "poclient"
    //     ? getPurchaseOrderReducer
    //     : getVendorPurchaseOrderReducer;

    // const data = listState?.purchaseOrders?.data
    //   ? listState.purchaseOrders.data
    //   : [];
    // setPaginationObj(listState?.purchaseOrders?.pagination);
    // setLoading(listState?.loading);

    const listState = isVendor
      ? getVendorPurchaseOrderReducer
      : getPurchaseOrderReducer;

    const data = listState?.purchaseOrders?.data
      ? listState.purchaseOrders.data
      : [];
    setPaginationObj(listState?.purchaseOrders?.pagination);
    setLoading(listState?.loading);

    data.map((purchase) => {
      const formatDate = new Date(purchase.date);
      const pdfUrl = purchase.pdfFileUrl || purchase.attachmentUrl || "";
      const hasAttachment = purchase?.poName && purchase?.poName !== "null";

      const statusText = purchase.isPublished === 0 ? "Created" : "Published";
      const purchaseObject = {
        privateKey: purchase.purchaseOrderId,
        purchaseOrderNumber: purchase.purchaseOrderNumber,
        purchaseOrderLineNumber: purchase.purchaseOrderLineNumber,
        vendorCode: purchase.vendorCode,
        purchaseOrderId: purchase.purchaseOrderId,
        itemCode: purchase.itemCode,
        itemDescription: purchase.itemDescription,
        isReleased: purchase.isPublished,
        date: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "do MMMM yyyy",
        ),
        qty: purchase.qty,
        unloadingPoint:
          purchase.unloadingPoint == (undefined || null || "undefined")
            ? "NA"
            : purchase.unloadingPoint,
        deliveryPlant:
          purchase.deliveryPlant == (undefined || null || "undefined")
            ? "NA"
            : purchase.deliveryPlant,
        status: statusText,
        isEditable: purchase.isEditable,
        pdfFileUrl: pdfUrl,
        action: (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {viewAttachmentAccess ? (
              <>
                {hasAttachment ? (
                  <ViewButton
                    tooltip="View Attachment"
                    variant="gradient"
                    color="info"
                    iconOnly
                    type="button"
                    onClick={() => onViewAttachmentClient(purchase)}
                  >
                    <Icon>visibility</Icon>
                  </ViewButton>
                ) : (
                  <ViewButton
                    tooltip="No Attachment"
                    variant="gradient"
                    style={{
                      background: "grey",
                      color: "white",
                      opacity: 0.5,
                      borderRadius: 5,
                    }}
                    iconOnly
                    type="button"
                    disabled
                  >
                    <Icon>visibility</Icon>
                  </ViewButton>
                )}

                {publishPOAccess && (
                  <Tooltip title="Publish">
                    <ReleaseButton
                      tooltip="Publish"
                      disabled={purchase.isPublished === 1}
                      type="button"
                      variant="gradient"
                      color="success"
                      iconOnly
                      onClick={() => handleOpenPublishModal(purchase)}
                    >
                      <Icon>forward</Icon>
                    </ReleaseButton>
                  </Tooltip>
                )}
                {updatePOAccess && (
                  <EditButton
                    tooltip="Edit"
                    disabled={purchase.isPublished === 1}
                    variant="gradient"
                    color="success"
                    iconOnly
                    type="button"
                    onClick={() => handleOpenUpdatePurchaseOrderModal(purchase)}
                  >
                    <Icon>edit_sharp</Icon>
                  </EditButton>
                )}
                {deletePOAccess && (
                  <DeleteButton
                    tooltip="Delete"
                    disabled={purchase.isPublished === 1}
                    variant="gradient"
                    color="error"
                    iconOnly
                    type="button"
                    onClick={() => handleOpenDeleteModal(purchase)}
                  >
                    <Icon>delete</Icon>
                  </DeleteButton>
                )}
              </>
            ) : (
              <></>
            )}

            {acceptPOAccess && (
              <Tooltip title="Accept">
                <MDButton
                  tooltip="Accept"
                  variant="gradient"
                  size="small"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() =>
                    openSingleVendorDecisionModal(purchase, "ACCEPT")
                  }
                >
                  <Icon>check_circle</Icon>
                </MDButton>
              </Tooltip>
            )}
            {rejectPOAccess && (
              <Tooltip title="Reject">
                <MDButton
                  tooltip="Reject"
                  variant="gradient"
                  size="small"
                  color="error"
                  iconOnly
                  type="button"
                  onClick={() =>
                    openSingleVendorDecisionModal(purchase, "REJECT")
                  }
                >
                  <Icon>cancel</Icon>
                </MDButton>
              </Tooltip>
            )}
          </div>
        ),
      };
      tempAsset.push(purchaseObject);
    });

    setState({ ...state, rows: tempAsset });
  }, [
    isVendor,
    getPurchaseOrderReducer,
    getVendorPurchaseOrderReducer,
    viewAccess,
  ]);

  const [fileForTestCertificate, setFileForTestCertificate] = useState({});
  const handleChangeForTestCertificate = (event) => {
    setFileForTestCertificate(event.target.files);
  };

  const [fileForInvoiceFile, setFileForInvoiceFile] = useState({});
  const handleChangeForInvoiceFile = (event) => {
    setFileForInvoiceFile(event.target.files);
  };

  const [openCreatePoModal, setOpenCreatePoModal] = useState(false);

  const handleOpenCreatePoModal = () => {
    setOpenCreatePoModal(true);
    formikForCreatePo.setValues(initialValueForCreatePo);
    formikForCreatePo.setTouched({});
    formikForCreatePo.setErrors({});
    setSelectedItemCode("");
    setSelectedVendorCode("");

    getVendorCodes(jwtToken);
    getItemMaster(jwtToken);
  };

  const handleCloseCreateProductionModal = () => {
    setOpenCreatePoModal(false);
  };

  const initialValueForCreatePo = {
    poDate: "",
    vendorCode: "",
    itemCode: "",
    poNo: "",
    poLineNo: "",
    reqQty: "",
    files: null,
    unloadingPoint: "",
    deliveryPlant: "",
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const validationSchemaForPo = Yup.object({
    poDate: Yup.date().min(today, "Date cannot be in the past!"),
    poNo: Yup.string().required("Enter PO No."),
    vendorCode: Yup.object().required("Select Vendor Code"),
    itemCode: Yup.string(),
    poLineNo: Yup.string().required("Enter PO Line No."),
    reqQty: Yup.string().required("Enter a qty"),
    unloadingPoint: Yup.string(),
    deliveryPlant: Yup.string(),
    files: Yup.mixed().required("Please upload a file"),
  });

  const onSubmitForCreatePo = async (values, { resetForm }) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("purchaseOrderNumber", values.poNo);
    formData.append("purchaseOrderLineNumber", values.poLineNo);
    formData.append("itemCode", values.itemCode);
    formData.append("itemId", selectedItemCode?.value);
    formData.append("date", values.poDate);
    formData.append("qty", values.reqQty);
    formData.append("unloadingPoint", (values.unloadingPoint || "").trim());
    formData.append("deliveryPlant", (values.deliveryPlant || "").trim());
    formData.append("email", email);
    formData.append("vendorCode", selectedVendorCode?.value);
    if (values.files) {
      formData.append("files", values.files);
    }

    try {
      let res = await createPurchaseOrderNew(formData, jwtToken);

      if (res.status) {
        setIsSuccessForCreateOrder(true);
        getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);
        setSelectedItemCode("");
        setSelectedVendorCode("");
        setTimeout(() => {
          handleCloseCreateProductionModal();
        }, 2000);
        resetForm();
      } else {
        setIsErrorForCreateOrder(true);
        setErrorMsgForCreate(res?.data?.data?.msg);
      }
    } catch (error) {
      setIsErrorForCreateOrder(true);
      setErrorMsgForCreate(error.message || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  const formikForCreatePo = useFormik({
    initialValues: initialValueForCreatePo,
    validationSchema: validationSchemaForPo,
    onSubmit: onSubmitForCreatePo,
  });

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [
    singlePurchaseOrderDataForDelete,
    setSinglePurchaseOrderDataForDelete,
  ] = useState({});

  const handleOpenDeleteModal = (asset = {}) => {
    setSinglePurchaseOrderDataForDelete(asset);
    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [isSuccessDelete, setIsSuccessDelete] = useState(false);

  useEffect(() => {
    if (isErrorDelete) {
      setTimeout(() => {
        setIsErrorDelete(false);
      }, 3000);
    }
  }, [isErrorDelete]);

  useEffect(() => {
    if (isSuccessDelete) {
      setTimeout(() => {
        setIsSuccessDelete(false);
      }, 3000);
    }
  }, [isSuccessDelete]);

  const deletePurchaseOrderData = async () => {
    let purchaseOrderId = Number(
      singlePurchaseOrderDataForDelete.purchaseOrderId,
    );

    let res = await deletePurchaseOrderNew(purchaseOrderId, email, jwtToken);

    if (res.status) {
      setIsSuccessDelete(true);
      handleCloseDeleteModal();
      // setTimeout(() => {
      //   handleCloseDeleteModal();
      // }, 2000);
      getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);
    }
    if (!res.status) {
      setIsErrorDelete(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
    }
  };
  const [isErrorMsgForRelease, setIsErrorMsgForRelease] = useState(false);

  const [openUpdatePurchaseOrderModal, setOpenUpdatePurchaseOrderModal] =
    useState(false);
  const [singlePurchaseOrderDataForUpdate, setPurchaseOrderDataForUpdate] =
    useState({});
  const handleOpenUpdatePurchaseOrderModal = (Asset = {}) => {
    setPurchaseOrderDataForUpdate(Asset);
    setOpenUpdatePurchaseOrderModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateProductionModal = () => {
    setOpenUpdatePurchaseOrderModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    reqQty: singlePurchaseOrderDataForUpdate.qty,
    eDate: singlePurchaseOrderDataForUpdate.date?.slice(0, 10),
  };

  const [selectedItemCode, setSelectedItemCode] = useState("");
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
        itemCode: item.itemCode,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [selectedVendorCode, setSelectedVendorCode] = useState("");
  const handleVendorCodeChange = (selectedItemCode) => {
    setSelectedVendorCode(selectedItemCode);
  };

  const [vendorCodeOptions, setVendorCodeOptions] = useState([]);
  useEffect(() => {
    let tempVendorCodeOptions = [];
    let data = getVendorCodeReducer.vendors.data
      ? getVendorCodeReducer.vendors.data
      : [];

    data.map((item) => {
      tempVendorCodeOptions.push({
        label: item.vendorName,
        value: item.vendorCode,
      });
    });
    setVendorCodeOptions(tempVendorCodeOptions);
  }, [getVendorCodeReducer]);

  const onSubmitForUpdate = async (values) => {
    let payload = {
      purchaseOrderId: singlePurchaseOrderDataForUpdate.purchaseOrderId,
      qty: values.reqQty,
      date: values.eDate,
      email: email,
    };

    let res = await editPurchaseOrderNew(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseUpdateProductionModal();
      }, 2000);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  const [openCreateReleaseModal, setOpenCreateReleaseModal] = useState(false);
  const handleCloseCreateReleaseModal = () => {
    setOpenCreateReleaseModal(false);
  };

  const [uncheck, setUncheck] = useState(false);

  const [selectedReleaseData, setSelectedReleaseData] = useState([]);

  // const ReleaseForData = (data) => {
  //   setSelectedReleaseData(data);
  // };

  const ReleaseForData = (data) => {
    // Remove already released PO from selection
    const filteredData = data.filter(
      (item) => item.isReleased !== 1 && item.isPublished !== 1,
    );
    setSelectedReleaseData(filteredData);
  };

  const onClickCreateReleaseList = async () => {
    // let tempArray = selectedReleaseData.map((data) => ({
    //   purchaseOrderId: data.purchaseOrderId,
    // }));

    // let payload = {
    //   purchaseOrderIds: tempArray,
    // };

    let purchaseOrderIds = selectedReleaseData.map(
      (item) => item.purchaseOrderId,
    );

    let payload = {
      purchaseOrderIds: purchaseOrderIds,
    };

    let res = await publishPoNew(payload, jwtToken);

    if (res.status) {
      setUncheck(!uncheck);
      setIsSuccessRelease(true);
      getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateReleaseModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorRelease(true);
      setIsErrorMsgForRelease(res?.data?.data?.msg);
    }
  };

  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    let value = selectedReleaseData.some((data) => data.isPublished === 1);
    setDisableButton(value);
  }, [selectedReleaseData]);

  const [isErrorPublish, setIsErrorPublish] = useState(false);
  const [isSuccessPublish, setIsSuccessPublish] = useState(false);

  useEffect(() => {
    if (isErrorPublish) {
      setTimeout(() => {
        setIsErrorPublish(false);
      }, 3000);
    }
  }, [isErrorPublish]);

  useEffect(() => {
    if (isSuccessPublish) {
      setTimeout(() => {
        setIsSuccessPublish(false);
      }, 3000);
    }
  }, [isSuccessPublish]);

  const [isErrorMsgForPublish, setIsErrorMsgForPublish] = useState(false);
  const [singlePublishData, setSinglePublishData] = useState({});
  const [openPublishModal, setOpenPublishModal] = useState(false);

  const handleOpenPublishModal = (asset = {}) => {
    setSinglePublishData(asset);
    setOpenPublishModal(true);
  };
  const handleClosePublishModal = () => {
    setOpenPublishModal(false);
  };

  const publishData = async () => {
    let payload = [
      {
        purchaseOrderId: singlePublishData.purchaseOrderId,
      },
    ];

    let response = await publishPoNew(payload, jwtToken);

    if (response.status) {
      setIsSuccessPublish(true);
      getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleClosePublishModal();
      }, 2250);
    }
    if (!response.status) {
      setIsErrorPublish(true);
      setIsErrorMsgForPublish(response?.data?.data?.msg);
    }
  };

  const [openVendorDecision, setOpenVendorDecision] = useState(false);
  const [vendorDecisionType, setVendorDecisionType] = useState(null);
  const [selectedPoForDecision, setSelectedPoForDecision] = useState(null);
  const [rejectReason, setRejectReason] = useState("");

  const openSingleVendorDecisionModal = (po, type) => {
    setSelectedPoForDecision(po);
    setVendorDecisionType(type);
    setRejectReason("");
    setOpenVendorDecision(true);
  };
  const closeVendorDecisionModal = () => setOpenVendorDecision(false);

  const confirmVendorDecision = async () => {
    const payload = [
      {
        purchaseOrderId: selectedPoForDecision.purchaseOrderId,
        reason: vendorDecisionType === "REJECT" ? rejectReason : undefined,
      },
    ];
    let res =
      vendorDecisionType === "ACCEPT"
        ? await acceptPoNew(payload, jwtToken)
        : await rejectPo(payload, jwtToken);

    if (res?.status) {
      toast.success(
        `PO ${
          vendorDecisionType === "ACCEPT" ? "accepted" : "rejected"
        } successfully!`,
      );
      getVendorPurchaseOrder(
        email,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      closeVendorDecisionModal();
    } else {
      toast.error(res?.data?.data?.msg || "Action failed");
    }
  };

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [openVendorBulkModal, setOpenVendorBulkModal] = useState(false);
  const [vendorBulkType, setVendorBulkType] = useState(null);
  const [bulkRejectReason, setBulkRejectReason] = useState("");

  const handleVendorBulk = (type) => {
    if (!selectedOrders.length) {
      toast.error("Select at least one PO");
      return;
    }
    setVendorBulkType(type);
    setBulkRejectReason("");
    setOpenVendorBulkModal(true);
  };

  const confirmVendorBulk = async () => {
    const payload = selectedOrders.map((order) => ({
      purchaseOrderId: order.purchaseOrderId,
      reason: vendorBulkType === "REJECT" ? bulkRejectReason : undefined,
    }));
    const res =
      vendorBulkType === "ACCEPT"
        ? await acceptPoNew(payload, jwtToken)
        : await rejectPo(payload, jwtToken);

    if (res?.status) {
      toast.success(
        `Selected POs ${
          vendorBulkType === "ACCEPT" ? "accepted" : "rejected"
        } successfully!`,
      );
      setUncheck(!uncheck);
      getVendorPurchaseOrder(
        email,
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setOpenVendorBulkModal(false);
    } else {
      toast.error(res?.data?.data?.msg || "Bulk PO's failed");
    }
  };

  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleAskConfirm = () => {
    if (!selectedClientOrders.length) return;
    setConfirmOpen(true);
  };

  const handleConfirmClose = () => setConfirmOpen(false);

  // const handleConfirmProceed = async () => {
  //   setConfirmOpen(false);
  //   await downloadInvoices();
  // };

  const handleConfirmProceed = async () => {
    downloadInvoices(selectedClientOrders);
    // setOpenCreateReleaseModal(true);
  };

  const [selectedClientOrders, setSelectedClientOrders] = useState([]);
  const downloadInvoices = async (orders) => {
    if (!orders.length) return;

    let payload = orders
      .filter((order) => order.status !== "Published")
      .map((order) => ({
        purchaseOrderId: order.purchaseOrderId,
      }));

    if (!payload.length) {
      toast.info("All selected POs are already published!");
      return;
    }

    try {
      const response = await publishPoNew(payload, jwtToken);
      if (response?.data?.success || response?.status) {
        toast.success("Selected POs published successfully!");
        getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);
        setUncheck(!uncheck);
        setSelectedClientOrders([]);
      } else {
        toast.error("Failed to publish selected POs");
      }
    } catch (err) {
      toast.error("Publish failed");
    }
  };

  useEffect(() => {
    let value = selectedClientOrders.some(
      (data) => data.status === "Published",
    );
    setDisableButton(value);
  }, [selectedClientOrders]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={3}
            >
              <MDBox color="text" px={2} ml={2} mb={1}>
                {createPOAccess && (
                  <CreateButton
                    tooltip="Create Purchase Order"
                    color="info"
                    variant="contained"
                    type="button"
                    onClick={handleOpenCreatePoModal}
                    style={{ marginRight: "10px" }}
                    iconOnly
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )}
              </MDBox>
            </MDBox>

            <MDBox mt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted
                tableSearch
                showTotalEntries
                noEndBorder
                loading={loading}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                serverSidePagination
                paginationObj={paginationObj}
                pageNoValue={pageNo}
                rowsPerPageValue={rowsPerPage}
                pageNoProp={importPageNo}
                rowsPerPageProp={importRowsPerPage}
                searchProp={importSearch}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                options={{ draggable: false }}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
                uncheckProp={uncheck}
                // isRowSelectable={(params) => params.row.status !== "Published"}
                isRowSelectable={(params) => params.row.isReleased === 0}
                // isDisabled={true}
                disableButton={disableButton}
                // ReleaseForData={ReleaseForData}
                selectionButtonClick={
                  publishPOAccess ? setSelectedClientOrders : setSelectedOrders
                }
                selectionButtonComponent={
                  publishPOAccess ? (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <span>
                        <MDButton
                          color="success"
                          type="button"
                          style={{
                            marginTop: "0.5rem",
                            marginLeft: "1rem",
                            marginBottom: "0.8rem",
                          }}
                          onClick={handleConfirmProceed}
                          disabled={
                            selectedClientOrders.length === 0 ||
                            // selectedClientOrders.some((po) => po.isPublished === 1)
                            disableButton
                          }
                        >
                          Publish Selected PO's
                        </MDButton>
                      </span>
                      {disableButton && (
                        <span
                          style={{
                            marginLeft: "10px",
                            fontWeight: "500",
                            color: "red",
                          }}
                        >
                          Only non-published PO's will be published
                        </span>
                      )}
                    </span>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        marginTop: "0.5rem",
                        marginLeft: "1rem",
                        marginBottom: "0.8rem",
                      }}
                    >
                      <MDButton
                        color="success"
                        type="button"
                        onClick={() => handleVendorBulk("ACCEPT")}
                      >
                        Accept
                      </MDButton>
                      <MDButton
                        color="error"
                        type="button"
                        onClick={() => handleVendorBulk("REJECT")}
                      >
                        Reject
                      </MDButton>
                    </div>
                  )
                }
              />
            </MDBox>

            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              style={{ backdropFilter: "blur(5px)" }}
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Create PO Modal (Client only) */}
            <Modal
              open={openCreatePoModal}
              onClose={handleCloseCreateProductionModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForCreatePo}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Create Purchase Order
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={handleCloseCreateProductionModal}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForCreatePo.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Purchase Order Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              name="poDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreatePo.handleBlur}
                              onChange={formikForCreatePo.handleChange}
                              value={formikForCreatePo.values.poDate}
                              error={
                                formikForCreatePo.touched.poDate &&
                                formikForCreatePo.errors.poDate &&
                                true
                              }
                            />
                            {formikForCreatePo.touched.poDate &&
                              formikForCreatePo.errors.poDate && (
                                <TextError
                                  msg={formikForCreatePo.errors.poDate}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Item Code/Des
                            </MDTypography>

                            <MDInput
                              fullWidth
                              placeholder="Enter Item Code/Description"
                              name="itemCode"
                              value={formikForCreatePo.values.itemCode || ""}
                              onChange={formikForCreatePo.handleChange}
                              onBlur={formikForCreatePo.handleBlur}
                            />
                            {formikForCreatePo.touched.itemCode &&
                              formikForCreatePo.errors.itemCode && (
                                <TextError
                                  msg={formikForCreatePo.errors.itemCode}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Vendor Code
                            </MDTypography>

                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Choose one..."
                              name="vendorCode"
                              onBlur={() => {
                                formikForCreatePo.handleBlur({
                                  target: { name: "vendorCode" },
                                });
                              }}
                              value={selectedVendorCode}
                              options={vendorCodeOptions}
                              onChange={(selectedOption) => {
                                handleVendorCodeChange(selectedOption);
                                formikForCreatePo.setFieldValue(
                                  "vendorCode",
                                  selectedOption,
                                );
                              }}
                            />

                            {formikForCreatePo.touched.vendorCode &&
                              formikForCreatePo.errors.vendorCode && (
                                <TextError
                                  msg={formikForCreatePo.errors.vendorCode}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              PO No
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="poNo"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreatePo.handleBlur}
                              onChange={formikForCreatePo.handleChange}
                              value={formikForCreatePo.values.poNo}
                              error={
                                formikForCreatePo.touched.poNo &&
                                formikForCreatePo.errors.poNo &&
                                true
                              }
                            />
                            {formikForCreatePo.touched.poNo &&
                              formikForCreatePo.errors.poNo && (
                                <TextError
                                  msg={formikForCreatePo.errors.poNo}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              PO Line No
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="poLineNo"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreatePo.handleBlur}
                              onChange={formikForCreatePo.handleChange}
                              value={formikForCreatePo.values.poLineNo}
                              error={
                                formikForCreatePo.touched.poLineNo &&
                                formikForCreatePo.errors.poLineNo &&
                                true
                              }
                            />
                            {formikForCreatePo.touched.poLineNo &&
                              formikForCreatePo.errors.poLineNo && (
                                <TextError
                                  msg={formikForCreatePo.errors.poLineNo}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Unloading Point
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="unloadingPoint"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreatePo.handleBlur}
                              onChange={formikForCreatePo.handleChange}
                              value={formikForCreatePo.values.unloadingPoint}
                              error={
                                formikForCreatePo.touched.unloadingPoint &&
                                formikForCreatePo.errors.unloadingPoint &&
                                true
                              }
                              inputProps={{
                                maxLength: 45,
                              }}
                            />
                            {formikForCreatePo.touched.unloadingPoint &&
                              formikForCreatePo.errors.unloadingPoint && (
                                <TextError
                                  msg={formikForCreatePo.errors.unloadingPoint}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Delivery Plant
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="deliveryPlant"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreatePo.handleBlur}
                              onChange={formikForCreatePo.handleChange}
                              value={formikForCreatePo.values.deliveryPlant}
                              error={
                                formikForCreatePo.touched.deliveryPlant &&
                                formikForCreatePo.errors.deliveryPlant &&
                                true
                              }
                              inputProps={{
                                maxLength: 45,
                              }}
                            />
                            {formikForCreatePo.touched.deliveryPlant &&
                              formikForCreatePo.errors.deliveryPlant && (
                                <TextError
                                  msg={formikForCreatePo.errors.deliveryPlant}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Required Qty
                            </MDTypography>

                            <MDInput
                              type="number"
                              name="reqQty"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreatePo.handleBlur}
                              onChange={formikForCreatePo.handleChange}
                              value={formikForCreatePo.values.reqQty}
                              error={
                                formikForCreatePo.touched.reqQty &&
                                formikForCreatePo.errors.reqQty &&
                                true
                              }
                            />
                            {formikForCreatePo.touched.reqQty &&
                              formikForCreatePo.errors.reqQty && (
                                <TextError
                                  msg={formikForCreatePo.errors.reqQty}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Attachment
                            </MDTypography>

                            <input
                              type="file"
                              name="files"
                              onChange={(event) => {
                                formikForCreatePo.setFieldValue(
                                  "files",
                                  event.currentTarget.files[0],
                                );
                              }}
                            />

                            {formikForCreatePo.touched.files &&
                              formikForCreatePo.errors.files && (
                                <TextError
                                  msg={formikForCreatePo.errors.files}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <MDBox mt={2}>
                          <Collapse in={isSuccessForCreateOrder}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessForCreateOrder(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Purchase Order created successfully!
                            </Alert>
                          </Collapse>
                          <Collapse in={isErrorForCreateOrder}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForCreateOrder(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForCreate}
                            </Alert>
                          </Collapse>
                        </MDBox>

                        <MDButton
                          type="submit"
                          color="info"
                          fullWidth
                          disabled={!formikForCreatePo.isValid || loading}
                        >
                          Create
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Attachment Preview Modal */}

            <Modal
              open={openAttachmentModal}
              onClose={() => setOpenAttachmentModal(false)}
              aria-labelledby="modal-attachment-title"
              aria-describedby="modal-attachment-desc"
            >
              <MDCard sx={styleForCreatePo}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Attachment Preview
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={() => setOpenAttachmentModal(false)}
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />
                <MDBox pt={1} pb={3} px={3} style={{ height: 600 }}>
                  {attachmentUrl ? (
                    attachmentUrl.match(/.(jpg|jpeg|png)$/i) ? (
                      <img
                        src={attachmentUrl}
                        alt="Attachment Preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <iframe
                        src={attachmentUrl}
                        title="Attachment"
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "none",
                        }}
                      />
                    )
                  ) : (
                    <MDTypography>No attachment to preview.</MDTypography>
                  )}
                </MDBox>
              </MDCard>
            </Modal>

            {/* Update Modal */}
            <Modal
              open={openUpdatePurchaseOrderModal}
              onClose={handleCloseUpdateProductionModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseUpdateProductionModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>

                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox mb={2}>
                      <MDTypography variant="h6"> Qty</MDTypography>
                      <MDInput
                        type="number"
                        name="reqQty"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForUpdate.handleBlur}
                        onChange={formikForUpdate.handleChange}
                        value={formikForUpdate.values.reqQty}
                        error={
                          formikForUpdate.touched.reqQty &&
                          formikForUpdate.errors.reqQty &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForUpdate.touched.reqQty &&
                        formikForUpdate.errors.reqQty && (
                          <TextError msg={formikForUpdate.errors.reqQty} />
                        )}
                    </MDBox>
                    <MDBox mb={2}>
                      <MDTypography variant="h6"> Date</MDTypography>
                      <MDInput
                        type="date"
                        name="eDate"
                        fullWidth
                        autoComplete="off"
                        onBlur={formikForUpdate.handleBlur}
                        onChange={formikForUpdate.handleChange}
                        value={formikForUpdate.values.eDate}
                        error={
                          formikForUpdate.touched.eDate &&
                          formikForUpdate.errors.eDate &&
                          true
                        }
                        inputProps={{
                          maxLength: 45,
                        }}
                      />
                      {formikForUpdate.touched.eDate &&
                        formikForUpdate.errors.eDate && (
                          <TextError msg={formikForUpdate.errors.eDate} />
                        )}
                    </MDBox>
                    <MDBox>
                      <Collapse in={isErrorForUpdate}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForUpdate}
                        </Alert>
                      </Collapse>
                      <Collapse in={isSuccessForUpdate}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorForUpdate(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Updated successfully
                        </Alert>
                      </Collapse>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="success"
                        fullWidth
                        type="submit"
                        disabled={!formikForUpdate.isValid}
                      >
                        Submit
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Delete Modal */}
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2} display="flex">
                  <div>
                    <MDButton
                      style={{ width: "100%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseDeleteModal}
                    >
                      Cancel
                    </MDButton>
                  </div>
                  <div style={{ float: "right" }}>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="error"
                      onClick={deletePurchaseOrderData}
                    >
                      Delete
                    </MDButton>
                  </div>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessDelete}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessDelete(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Deleted successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorDelete}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorDelete(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsgForDelete}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Release Modal (Client bulk) */}
            <Modal
              open={openCreateReleaseModal}
              onClose={handleCloseCreateReleaseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForRelease}>
                <MDTypography>Are you sure you want to Publish ?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateReleaseModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="info"
                    onClick={onClickCreateReleaseList}
                  >
                    Publish
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessRelease}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessRelease(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Published successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorRelease}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorRelease(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForRelease}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Publish Single Modal (Client) */}
            <Modal
              open={openPublishModal}
              onClose={handleClosePublishModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to Publish?</MDTypography>
                <MDBox mt={2} display="flex">
                  <div>
                    <MDButton
                      style={{ width: "100%", marginRight: "1.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleClosePublishModal}
                    >
                      Cancel
                    </MDButton>
                  </div>
                  <div style={{ float: "right" }}>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={publishData}
                    >
                      Publish
                    </MDButton>
                  </div>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessPublish}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessPublish(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Purchase Order Published successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorPublish}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorPublish(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForPublish}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Vendor Single Decision Modal */}
            <Modal
              open={openVendorDecision}
              onClose={closeVendorDecisionModal}
              aria-labelledby="modal-vendor-decision-title"
              aria-describedby="modal-vendor-decision-desc"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>
                  {vendorDecisionType === "ACCEPT"
                    ? "Accept this PO?"
                    : "Reject this PO?"}
                </MDTypography>
                {vendorDecisionType === "REJECT" && (
                  <MDBox mt={1}>
                    <MDTypography variant="h6">Reason (optional)</MDTypography>
                    <MDInput
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                      fullWidth
                    />
                  </MDBox>
                )}
                <MDBox mt={2} display="flex">
                  <MDButton
                    style={{ width: "100%", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={closeVendorDecisionModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "100%", marginLeft: "0.5rem" }}
                    color={
                      vendorDecisionType === "ACCEPT" ? "success" : "error"
                    }
                    onClick={confirmVendorDecision}
                  >
                    {vendorDecisionType === "ACCEPT" ? "Accept" : "Reject"}
                  </MDButton>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Vendor Bulk Modal */}
            <Modal
              open={openVendorBulkModal}
              onClose={() => setOpenVendorBulkModal(false)}
              aria-labelledby="modal-vendor-bulk-title"
              aria-describedby="modal-vendor-bulk-desc"
            >
              <MDCard sx={styleForRelease}>
                <MDTypography>
                  {vendorBulkType === "ACCEPT"
                    ? "Are you sure you want to Accept selected POs?"
                    : "Are you sure you want to Reject selected POs?"}
                </MDTypography>
                {vendorBulkType === "REJECT" && (
                  <MDBox mt={1}>
                    <MDTypography variant="h6">Reason (optional)</MDTypography>
                    <MDInput
                      value={bulkRejectReason}
                      onChange={(e) => setBulkRejectReason(e.target.value)}
                      fullWidth
                    />
                  </MDBox>
                )}
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={() => setOpenVendorBulkModal(false)}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color={vendorBulkType === "ACCEPT" ? "success" : "error"}
                    onClick={confirmVendorBulk}
                  >
                    {vendorBulkType === "ACCEPT" ? "Accept" : "Reject"}
                  </MDButton>
                </MDBox>
                <Modal open={confirmOpen} onClose={handleConfirmClose}>
                  <div>
                    <Typography>
                      Are you sure you want to publish selected PO's?
                    </Typography>
                    <button onClick={handleConfirmProceed}>Yes, Publish</button>
                    <button onClick={handleConfirmClose}>Cancel</button>
                  </div>
                </Modal>
              </MDCard>
            </Modal>
          </Card>
        </Grid>
      </Grid>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getPurchaseOrderReducer: state.getPurchaseOrderReducer,
    profileData: state.profile,
    itemMaster: state.itemMaster,
    getVendorCodeReducer: state.getVendorCodeReducer,
    packageTypeReducer: state.packageTypeReducer,
    packageDetailsReducer: state.packageDetailsReducer,
    deliveryPlantForPOReducer: state.deliveryPlantForPOReducer,
    unloadingPointForPOReducer: state.unloadingPointForPOReducer,
    packetWeightReducer: state.packetWeightReducer,
    binsForPrintReducer: state.binsForPrintReducer,
    getVendorPurchaseOrderReducer: state.getVendorPurchaseOrderReducer,
    getAttechmentClientReducer: state.getAttechmentClientReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getPurchaseOrderNew: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getPurchaseOrderNew(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    getVendorCodes: (jwtToken) => dispatch(getVendorCodes(jwtToken)),
    deletePurchaseOrderNew: (purchaseOrderId, email, jwtToken) =>
      dispatch(deletePurchaseOrderNew(purchaseOrderId, email, jwtToken)),
    publishPurchaseOrder: (payload, jwtToken) =>
      dispatch(publishPurchaseOrder(payload, jwtToken)),
    createPurchaseOrderNew: (payload, jwtToken) =>
      dispatch(createPurchaseOrderNew(payload, jwtToken)),
    editPurchaseOrderNew: (payload, jwtToken) =>
      dispatch(editPurchaseOrderNew(payload, jwtToken)),
    uploadForPurchaseOrder: (payload, jwtToken) =>
      dispatch(uploadForPurchaseOrder(payload, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    publishPoNew: (payload, jwtToken) =>
      dispatch(publishPoNew(payload, jwtToken)),
    getBinsForPrint: (asnCode, jwtToken) =>
      dispatch(getBinsForPrint(asnCode, jwtToken)),
    getPackageType: (partCode, jwtToken) =>
      dispatch(getPackageType(partCode, jwtToken)),
    calculatePacketWeight: (partCode, asnQtyChange, jwtToken) =>
      dispatch(calculatePacketWeight(partCode, asnQtyChange, jwtToken)),
    getUnloadingPointForPO: (id, jwtToken) =>
      dispatch(getUnloadingPointForPO(id, jwtToken)),
    getDeliveryPlantForPO: (id, jwtToken) =>
      dispatch(getDeliveryPlantForPO(id, jwtToken)),
    createAsn: (payload, jwtToken) => dispatch(createAsn(payload, jwtToken)),
    calculatePacketDetails: (asnQty, partCode, email, jwtToken) =>
      dispatch(calculatePacketDetails(asnQty, partCode, email, jwtToken)),
    // NEW
    acceptPoNew: (payload, jwtToken) =>
      dispatch(acceptPoNew(payload, jwtToken)),
    rejectPo: (payload, jwtToken) => dispatch(rejectPo(payload, jwtToken)),

    getVendorPurchaseOrder: (pageNo, rowsPerPage, search, jwtToken) =>
      dispatch(getVendorPurchaseOrder(pageNo, rowsPerPage, search, jwtToken)),

    getAttechmentClient: (purchaseOrderId, jwtToken) =>
      dispatch(getAttechmentClient(purchaseOrderId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePO);
